import { useEffect } from 'react';

/** Закрытие по Escape. Вынесено, чтобы не повторять слушатель в каждом окне. */
export function useEscape(onEscape: () => void, isActive = true): void {
  useEffect(() => {
    if (!isActive) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onEscape();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onEscape, isActive]);
}
